import { createContext, useContext, type ReactNode } from "react";
import { useTopBanners } from "../services/queries";

type BannerResponse = {
  b: string[];
  t: string[];
};

type BannerContextType = {
  banners: BannerResponse;
  loading: boolean;
};

const BannerContext = createContext<BannerContextType>({
  banners: { b: [], t: [] },
  loading: false,
});

export const BannerProvider = ({ children }: { children: ReactNode }) => {
  const { data: banners = { b: [], t: [] }, isLoading: loading } = useTopBanners();

  return (
    <BannerContext.Provider value={{ banners, loading }}>
      {children}
    </BannerContext.Provider>
  );
};

export const useBannerContext = () => useContext(BannerContext);
